import { useAppSelector } from 'store/store';
import { ROLE_TENANT_TECHNICIAN } from 'shared/permissions/roles';

export function useIsTechnician(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups?.includes(ROLE_TENANT_TECHNICIAN) ?? false;
}
